import React, { useCallback, useState, useEffect, useRef } from 'react'
import { MunicipalityChart } from 'components/municipalityChart/component'
import LOCALES from './locales.js'
import './styles.scss'

interface Props {
  data: []
  locale: string
  selectedMunicipalityNumber: number
}

export const MunicipalityChartContainer = ({
  data,
  locale,
  selectedMunicipalityNumber
}: Props) => {
  const [width, setWidth] = useState(0)
  const nodeContainer = useRef<HTMLElement | null>(null)

  const resize = () => {
    if (nodeContainer && nodeContainer.current) {
      setWidth(nodeContainer.current.offsetWidth)
    }
  }

  const container = useCallback(node => {
    nodeContainer.current = node
    resize()
  }, [])

  useEffect(() => {
    window.addEventListener('resize', resize)

    return () => {
      window.removeEventListener('resize', resize)
    }
  }, [])

  return (
    <>
      <h4 className='chart-title'>
        {LOCALES.title[locale]}
        <span className='lead'>{LOCALES.lead[locale]}</span>
      </h4>
      <div className='y-axis'>↑ {LOCALES.yaxis[locale]}</div>

      <div ref={container} className='municipality-chart'>
        {/* <div className='legend'>
          <div className='legend-no'><i /> <span>Commune ayant voté non</span></div>
          <div className='legend-yes'><i /> <span>Commune ayant voté oui</span></div>
        </div> */}
        <div className='overlay'>
          <div className='bck-no' />
          <div className='bck-yes' />
          <div className='center' />
          <div className='grid g1' />
          <div className='grid g2' />
          <div className='grid g3' />
          <div className='grid g4' />
          <div className='grid g5' />
          <div className='grid g6' />
        </div>
        <MunicipalityChart
          width={width}
          data={data}
          selectedMunicipalityNumber={selectedMunicipalityNumber}
        />
        <div className='axis'>
          <div className='left'>
            <div className='bar' />← 100% <b>{LOCALES.no[locale]}</b>{' '}
            <i className='ui icon circle times' />
          </div>
          <div className='right'>
            <div className='bar' />
            <i className='ui icon circle check' /> <b>{LOCALES.yes[locale]}</b>{' '}
            100% →
          </div>
        </div>
      </div>
    </>
  )
}

export default MunicipalityChartContainer
